"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountApiKeyClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class AccountApiKeyClient extends authenticated_client_1.AuthenticatedClient {
    add(accountId, key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/${accountId}/api-keys`, key);
            return response.payload;
        });
    }
    update(payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/accounts/${payload.accountId}/api-keys/${payload.id}`, payload);
            return response.payload;
        });
    }
    getAll(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/api-keys`);
            return response.payload;
        });
    }
    regenerate(accountId, id, regenerateRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/${accountId}/api-keys/${id}/regenerate`, regenerateRequest);
            return response.payload;
        });
    }
    getById(accountId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/accounts/${accountId}/api-keys/${id}`);
            return response.payload;
        });
    }
    revoke(accountId, id, revokePayload) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/accounts/${accountId}/api-keys/${id}/revoke`, revokePayload);
            return response.payload;
        });
    }
    getCalls(accountId, id, parameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let url = `/v1/accounts/${accountId}/api-keys/${id}/calls`;
            if (parameters) {
                url += `?${this.getQueryString(parameters)}`;
            }
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.AccountApiKeyClient = AccountApiKeyClient;
//# sourceMappingURL=account-api-keys.client.js.map